import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../i18n/LangContext';
import BeforeAfter from '../BeforeAfter';
import { ArrowRight } from 'lucide-react';

const J = 'https://static.prod-images.emergentagent.com/jobs/e72d340d-3899-4876-891e-4e00170d4616/images/';

const ITEMS = [
  { to: '/kitchen-remodeling-miami', before: J + '7118d548871784c0337c17be9c41951d49b0d13fcd4b203dd3ac0ba023d60307.jpeg', after: J + 'd891284e63eb62bc04a8428d6e2d5669550cd0656511fbcb02a0063670d63d51.jpeg', en: 'Kitchen Remodeling', es: 'Remodelación de Cocinas' },
  { to: '/bathroom-remodeling-miami', before: J + 'f73e5fb2bbaa51816a33ff6e45f49c3a3effe198ed2927bd9d3d69e0e24c92c9.jpeg', after: J + '195bda7a32d1be06927ab736c5d482a11d20f87030627f8701b324d368d93276.jpeg', en: 'Bathroom Remodeling', es: 'Remodelación de Baños' },
  { to: '/outdoor-living-miami', before: J + '17038ef5559850b285a4db70bc42d12f6272f0b2d5fada9e29de54bea3431aed.jpeg', after: J + 'b3c688c1a6ef759cfda84e90ae8232b3de81ab1ae06a0dbf963db8fe7875ba34.jpeg', en: 'Outdoor Living', es: 'Espacios Exteriores' },
  { to: '/multi-trade-miami', before: J + 'b42d276595e4edae67d12c0492a370ffc7e69f2d0f48be5b53fc86c704344f1f.jpeg', after: J + '2d44adc8561e05c68d29e17abff6073bc0d6a752bd4cdbeed30f5586e9285237.jpeg', en: 'Multi-Trade Refresh', es: 'Renovación Multi-Oficio' },
  { to: '/landscape-design-miami', before: J + '7d8f93435679f1ea2b12a1d398bfcdfeab46d0fec5b7503328fc9fdeb9b34b98.jpeg', after: J + 'b9e34c8cf52087634be9a2d90dc884380a05c37adb4891302f303bec9e611e34.jpeg', en: 'Landscape Design', es: 'Diseño de Paisajismo' },
  { to: '/general-contractor-miami', before: J + 'f11ba77a6efe82c4251de960c563490df5cc0c1ab298dd484be1a3f41866bffc.jpeg', after: J + '91e646bce06035faa7da530756f613e7709bb810a720d02480316020758120d7.jpeg', en: 'New Construction', es: 'Nueva Construcción' },
];

const COPY = {
  en: { label: 'AI Design Concepts', heading: 'See What Your Project Could Become', desc: 'Explore AI-generated before-and-after concepts across our services. Slide to compare, then open a service to plan your own transformation.', view: 'Explore this service' },
  es: { label: 'Conceptos de Diseño con IA', heading: 'Vea en Qué Podría Convertirse Su Proyecto', desc: 'Explore conceptos antes-y-después generados con IA en nuestros servicios. Deslice para comparar y abra un servicio para planear su propia transformación.', view: 'Explorar este servicio' },
};

export default function HomeConceptGallery() {
  const { lang, t } = useLang();
  const copy = COPY[lang] || COPY.en;
  const c = t.compare;
  return (
    <section id="ai-concepts" className="bg-[#0B0D0F] py-20 sm:py-28 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-[#D4AF37] text-xs font-mono tracking-[0.25em] uppercase">{copy.label}</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mt-3 font-outfit">{copy.heading}</h2>
          <p className="text-slate-400 mt-4 max-w-2xl mx-auto">{copy.desc}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ITEMS.map((it) => (
            <div key={it.to} data-testid={`concept-card-${it.to}`} className="bg-[#12151A] border border-white/8 rounded-lg p-4 hover:border-[#D4AF37]/30 transition-all">
              <BeforeAfter
                beforeSrc={it.before} afterSrc={it.after}
                beforeLabel={c.existingIllustrative} afterLabel={c.concept}
                beforeAlt={`${c.existingIllustrative} — ${it[lang] || it.en}`}
                afterAlt={`${c.concept} — ${it[lang] || it.en}`}
                showNotice={false}
              />
              <div className="flex items-center justify-between mt-4">
                <h3 className="text-white font-semibold font-outfit">{it[lang] || it.en}</h3>
                <Link to={it.to} className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#D4AF37] hover:text-white transition-colors">
                  {copy.view}<ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          ))}
        </div>
        <p className="text-slate-500 text-xs italic text-center mt-10 max-w-3xl mx-auto">{c.notice}</p>
      </div>
    </section>
  );
}
